/**
 * "שכחתי סיסמה"  —  /forgot-password
 * שולח מייל איפוס. ההמשך ב-ResetPasswordPage.
 */
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Link,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { authService } from '../services/authService';
import { getApiError } from '../utils/apiError';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await authService.requestPasswordReset(email);
      setSent(true);
    } catch (err: any) {
      setError(getApiError(err, 'לא הצלחנו לשלוח את המייל. נסי שוב.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        p: 2,
      }}
    >
      <Card dir="rtl" sx={{ width: '100%', maxWidth: 420 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" sx={{ fontWeight: 600, color: 'primary.dark', mb: 0.5 }}>
            איפוס סיסמה
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            נשלח לך קישור לבחירת סיסמה חדשה.
          </Typography>

          {sent ? (
            <Stack spacing={2}>
              <Alert severity="success">
                אם קיים חשבון עבור {email}, קישור לאיפוס בדרך אליך.
              </Alert>
              <Link component={RouterLink} to="/login" variant="body2" textAlign="center">
                חזרה להתחברות
              </Link>
            </Stack>
          ) : (
            <form onSubmit={handleSubmit}>
              <Stack spacing={2}>
                {error && <Alert severity="error">{error}</Alert>}
                <TextField
                  label="אימייל"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  autoFocus
                />
                <Button type="submit" variant="contained" disabled={submitting || !email} fullWidth>
                  {submitting ? 'שולח…' : 'שליחת קישור'}
                </Button>
                <Link component={RouterLink} to="/login" variant="body2" textAlign="center">
                  חזרה להתחברות
                </Link>
              </Stack>
            </form>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default ForgotPasswordPage;
